/* Veilleuse Nuage Étoilé — configurateur. Monté sur chaque [data-vn] de la page. */

(function(){

  /* Textes par langue. Les identifiants (rose, ours…) ne bougent jamais : ils servent à
     retrouver les images vn-<id>.webp. Seul l'affichage est traduit — ce qui part dans le
     panier reste en français, pour la production. */
  var VNT = {
  "fr": {
    "nuages": {
      "rose": "Rose",
      "menthe": "Menthe",
      "lilas": "Lilas",
      "ciel": "Ciel",
      "vanille": "Vanille"
    },
    "animaux": {
      "ours": "Ours",
      "zebre": "Zèbre",
      "loup": "Loup",
      "baleine": "Baleine",
      "licorne": "Licorne",
      "tortue": "Tortue",
      "tigre": "Tigre",
      "ecureuil": "Écureuil",
      "paresseux": "Paresseux",
      "mouton": "Mouton",
      "raton": "Raton laveur",
      "ourspolaire": "Ours polaire",
      "cochon": "Cochon",
      "manchot": "Manchot",
      "perroquet": "Perroquet",
      "panda": "Panda",
      "hibou": "Hibou",
      "singe": "Singe",
      "lion": "Lion",
      "koala": "Koala",
      "cheval": "Cheval",
      "hippo": "Hippopotame",
      "herisson": "Hérisson",
      "hamster": "Hamster",
      "gorille": "Gorille",
      "chevre": "Chèvre",
      "girafe": "Girafe",
      "grenouille": "Grenouille",
      "renard": "Renard",
      "flamant": "Flamant rose",
      "elephant": "Éléphant",
      "aigle": "Aigle",
      "canard": "Canard",
      "ane": "Âne",
      "dauphin": "Dauphin",
      "chien": "Chien",
      "dinosaure": "Dinosaure",
      "cerf": "Cerf",
      "crocodile": "Crocodile",
      "vache": "Vache",
      "poussin": "Poussin",
      "chat": "Chat",
      "castor": "Castor",
      "lapin": "Lapin",
      "kangourou": "Kangourou",
      "loutre": "Loutre"
    },
    "i": {
      "recap_initiale": "Initiale",
      "recap_animal": "Animal",
      "recap_nuage": "Nuage",
      "restants_un": "restant",
      "restants_plusieurs": "restants",
      "adaptateur_titre": "Ajouter l'adaptateur secteur USB",
      "adaptateur_aide": "Pour brancher la veilleuse sur une prise murale. Le câble USB est déjà fourni.",
      "bouton_apercu": "Voir l'aperçu de ma veilleuse",
      "aria_apercu": "Aperçu de la veilleuse personnalisée"
    }
  },
  "en": {
    "nuages": {
      "rose": "Pink",
      "menthe": "Mint",
      "lilas": "Lilac",
      "ciel": "Sky Blue",
      "vanille": "Vanilla"
    },
    "animaux": {
      "ours": "Bear",
      "zebre": "Zebra",
      "loup": "Wolf",
      "baleine": "Whale",
      "licorne": "Unicorn",
      "tortue": "Turtle",
      "tigre": "Tiger",
      "ecureuil": "Squirrel",
      "paresseux": "Sloth",
      "mouton": "Sheep",
      "raton": "Raccoon",
      "ourspolaire": "Polar bear",
      "cochon": "Pig",
      "manchot": "Penguin",
      "perroquet": "Parrot",
      "panda": "Panda",
      "hibou": "Owl",
      "singe": "Monkey",
      "lion": "Lion",
      "koala": "Koala",
      "cheval": "Horse",
      "hippo": "Hippo",
      "herisson": "Hedgehog",
      "hamster": "Hamster",
      "gorille": "Gorilla",
      "chevre": "Goat",
      "girafe": "Giraffe",
      "grenouille": "Frog",
      "renard": "Fox",
      "flamant": "Flamingo",
      "elephant": "Elephant",
      "aigle": "Eagle",
      "canard": "Duck",
      "ane": "Donkey",
      "dauphin": "Dolphin",
      "chien": "Dog",
      "dinosaure": "Dinosaur",
      "cerf": "Deer",
      "crocodile": "Crocodile",
      "vache": "Cow",
      "poussin": "Chick",
      "chat": "Cat",
      "castor": "Beaver",
      "lapin": "Rabbit",
      "kangourou": "Kangaroo",
      "loutre": "Otter"
    },
    "i": {
      "recap_initiale": "Initial",
      "recap_animal": "Animal",
      "recap_nuage": "Cloud",
      "restants_un": "left",
      "restants_plusieurs": "left",
      "adaptateur_titre": "Add the USB power adapter",
      "adaptateur_aide": "To plug the night light into a wall socket. The USB cable is already included.",
      "bouton_apercu": "See my night light preview",
      "aria_apercu": "Preview of the personalized night light"
    }
  },
  "de": {
    "nuages": {
      "rose": "Rosa",
      "menthe": "Mint",
      "lilas": "Flieder",
      "ciel": "Himmelblau",
      "vanille": "Vanille"
    },
    "animaux": {
      "ours": "Bär",
      "zebre": "Zebra",
      "loup": "Wolf",
      "baleine": "Wal",
      "licorne": "Einhorn",
      "tortue": "Schildkröte",
      "tigre": "Tiger",
      "ecureuil": "Eichhörnchen",
      "paresseux": "Faultier",
      "mouton": "Schaf",
      "raton": "Waschbär",
      "ourspolaire": "Eisbär",
      "cochon": "Schwein",
      "manchot": "Pinguin",
      "perroquet": "Papagei",
      "panda": "Panda",
      "hibou": "Eule",
      "singe": "Affe",
      "lion": "Löwe",
      "koala": "Koala",
      "cheval": "Pferd",
      "hippo": "Nilpferd",
      "herisson": "Igel",
      "hamster": "Hamster",
      "gorille": "Gorilla",
      "chevre": "Ziege",
      "girafe": "Giraffe",
      "grenouille": "Frosch",
      "renard": "Fuchs",
      "flamant": "Flamingo",
      "elephant": "Elefant",
      "aigle": "Adler",
      "canard": "Ente",
      "ane": "Esel",
      "dauphin": "Delfin",
      "chien": "Hund",
      "dinosaure": "Dinosaurier",
      "cerf": "Hirsch",
      "crocodile": "Krokodil",
      "vache": "Kuh",
      "poussin": "Küken",
      "chat": "Katze",
      "castor": "Biber",
      "lapin": "Hase",
      "kangourou": "Känguru",
      "loutre": "Otter"
    },
    "i": {
      "recap_initiale": "Initiale",
      "recap_animal": "Tier",
      "recap_nuage": "Wolke",
      "restants_un": "übrig",
      "restants_plusieurs": "übrig",
      "adaptateur_titre": "USB-Netzteil hinzufügen",
      "adaptateur_aide": "Um das Nachtlicht an eine Steckdose anzuschließen. Das USB-Kabel ist bereits enthalten.",
      "bouton_apercu": "Vorschau meines Nachtlichts ansehen",
      "aria_apercu": "Vorschau des personalisierten Nachtlichts"
    }
  },
  "es": {
    "nuages": {
      "rose": "Rosa",
      "menthe": "Menta",
      "lilas": "Lila",
      "ciel": "Celeste",
      "vanille": "Vainilla"
    },
    "animaux": {
      "ours": "Oso",
      "zebre": "Cebra",
      "loup": "Lobo",
      "baleine": "Ballena",
      "licorne": "Unicornio",
      "tortue": "Tortuga",
      "tigre": "Tigre",
      "ecureuil": "Ardilla",
      "paresseux": "Perezoso",
      "mouton": "Oveja",
      "raton": "Mapache",
      "ourspolaire": "Oso polar",
      "cochon": "Cerdo",
      "manchot": "Pingüino",
      "perroquet": "Loro",
      "panda": "Panda",
      "hibou": "Búho",
      "singe": "Mono",
      "lion": "León",
      "koala": "Koala",
      "cheval": "Caballo",
      "hippo": "Hipopótamo",
      "herisson": "Erizo",
      "hamster": "Hámster",
      "gorille": "Gorila",
      "chevre": "Cabra",
      "girafe": "Jirafa",
      "grenouille": "Rana",
      "renard": "Zorro",
      "flamant": "Flamenco",
      "elephant": "Elefante",
      "aigle": "Águila",
      "canard": "Pato",
      "ane": "Burro",
      "dauphin": "Delfín",
      "chien": "Perro",
      "dinosaure": "Dinosaurio",
      "cerf": "Ciervo",
      "crocodile": "Cocodrilo",
      "vache": "Vaca",
      "poussin": "Pollito",
      "chat": "Gato",
      "castor": "Castor",
      "lapin": "Conejo",
      "kangourou": "Canguro",
      "loutre": "Nutria"
    },
    "i": {
      "recap_initiale": "Inicial",
      "recap_animal": "Animal",
      "recap_nuage": "Nube",
      "restants_un": "restante",
      "restants_plusieurs": "restantes",
      "adaptateur_titre": "Añadir el adaptador de corriente USB",
      "adaptateur_aide": "Para enchufar la luz nocturna a la pared. El cable USB ya está incluido.",
      "bouton_apercu": "Ver la vista previa de mi luz nocturna",
      "aria_apercu": "Vista previa de la luz nocturna personalizada"
    }
  }
};

  var VN_LANG = (function(){
    var l = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
    return VNT[l] ? l : 'fr';
  })();
  var VTX = VNT[VN_LANG], VFR = VNT.fr;

  /* Montants : on emprunte money() à kp-personnalisation quand il est là — c'est la même
     source de vérité pour la langue et la devise. Sinon on refait la même chose, avec la
     même correction de l'espace insécable. */
  function money(centimes){
    var kp = window.kpPerso;
    if (kp && typeof kp.money === 'function') return kp.money(centimes);
    var n = centimes / 100;
    var devise = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var format = (document.documentElement.lang || 'fr');
    try {
      return new Intl.NumberFormat(format, { style: 'currency', currency: devise })
        .format(n).replace(/[\u00a0\u202f]/g, ' ');
    } catch (e) { return n.toFixed(2) + ' ' + devise; }
  }


  function init(root){

  if(root.dataset.vnPret) return; root.dataset.vnPret='1';

  var BASE=root.dataset.base, CARTE=root.dataset.carte;

  var LAYOUT={discX:310,discY:259,discR:184,discB:432,cloudW:280,cloudY:284,initS:270,initY:321,animS:140,animY:333,nameS:52,nameY:380};

  var NUAGES=[{id:'rose',n:'Rose',c:'#F6C1CF'},{id:'menthe',n:'Menthe',c:'#BFE6CF'},{id:'lilas',n:'Lilas',c:'#CFC3F0'},{id:'ciel',n:'Ciel',c:'#BCD8F5'},{id:'vanille',n:'Vanille',c:'#F8E7A6'}];

  var ANIMAUX=[['ours','Ours'],['zebre','Zèbre'],['loup','Loup'],['baleine','Baleine'],['licorne','Licorne'],['tortue','Tortue'],['tigre','Tigre'],['ecureuil','Écureuil'],['paresseux','Paresseux'],['mouton','Mouton'],['raton','Raton laveur'],['ourspolaire','Ours polaire'],['cochon','Cochon'],['manchot','Manchot'],['perroquet','Perroquet'],['panda','Panda'],['hibou','Hibou'],['singe','Singe'],['lion','Lion'],['koala','Koala'],['cheval','Cheval'],['hippo','Hippopotame'],['herisson','Hérisson'],['hamster','Hamster'],['gorille','Gorille'],['chevre','Chèvre'],['girafe','Girafe'],['grenouille','Grenouille'],['renard','Renard'],['flamant','Flamant rose'],['elephant','Éléphant'],['aigle','Aigle'],['canard','Canard'],['ane','Âne'],['dauphin','Dauphin'],['chien','Chien'],['dinosaure','Dinosaure'],['cerf','Cerf'],['crocodile','Crocodile'],['vache','Vache'],['poussin','Poussin'],['chat','Chat'],['castor','Castor'],['lapin','Lapin'],['kangourou','Kangourou'],['loutre','Loutre']];

  // placement de l'animal selon la lettre : x/y en unités du dessin (600 = largeur), s = échelle

  var DECALAGES={"A":{"x":50,"y":0,"s":0.86},"B":{"x":-49,"y":0,"s":0.86},"C":{"x":0,"y":0,"s":0.86},"D":{"x":0,"y":0,"s":0.86},"E":{"x":-50,"y":0,"s":0.86},"F":{"x":-48,"y":0,"s":0.86},"G":{"x":-42,"y":0,"s":0.86},"H":{"x":0,"y":0,"s":0.86},"I":{"x":-50,"y":0,"s":0.86},"J":{"x":38,"y":0,"s":0.86},"K":{"x":43,"y":0,"s":0.86},"L":{"x":-23,"y":0,"s":0.86},"M":{"x":41,"y":0,"s":0.86},"N":{"x":0,"y":0,"s":0.86},"O":{"x":0,"y":0,"s":0.86},"P":{"x":-31,"y":0,"s":0.86},"Q":{"x":0,"y":0,"s":0.86},"R":{"x":-38,"y":0,"s":0.86},"S":{"x":0,"y":0,"s":0.86},"T":{"x":46,"y":0,"s":0.86},"U":{"x":0,"y":0,"s":0.86},"V":{"x":-47,"y":0,"s":0.86},"W":{"x":16,"y":0,"s":0.86},"X":{"x":10,"y":0,"s":0.86},"Y":{"x":-44,"y":0,"s":0.86},"Z":{"x":11,"y":0,"s":0.86}};

  var REGLAGE=location.hash==='#reglages';

  if(REGLAGE){try{var sauve=JSON.parse(localStorage.getItem('vn-decalages')||'null');if(sauve)Object.assign(DECALAGES,sauve)}catch(e){}}

  var etat={nuage:'rose',initiale:'A',manuel:false,animal:'ours',prenom:''};

  var APERCU=root.querySelector('.vn__apercu');

  // l'aperçu peut être déplacé dans le carrousel : on cherche dans les deux

  function $(s){return root.querySelector(s)||APERCU.querySelector(s)}

  var VERSION_IMAGES='2';

  function img(id){return BASE+'vn-'+id+'.webp?v='+VERSION_IMAGES}

  function sansAccent(t){return t.normalize('NFD').replace(/[̀-ͯ]/g,'')}

  function fonce(h,f){var n=parseInt(h.slice(1),16),r=n>>16,g=n>>8&255,b=n&255;return 'rgb('+Math.round(r*f)+','+Math.round(g*f)+','+Math.round(b*f)+')'}



  // étoiles fixes imprimées sur le disque

  function etoile(x,y,s){return 'M'+x+' '+(y-s)+'Q'+(x+s*.18)+' '+(y-s*.18)+' '+(x+s)+' '+y+'Q'+(x+s*.18)+' '+(y+s*.18)+' '+x+' '+(y+s)+'Q'+(x-s*.18)+' '+(y+s*.18)+' '+(x-s)+' '+y+'Q'+(x-s*.18)+' '+(y-s*.18)+' '+x+' '+(y-s)+'Z'}

  $('[data-vn-etoiles]').innerHTML=[[160,150,9,'#F6D77A'],[440,140,8,'#F6D77A'],[124,262,6,'#FFFFFF'],[478,250,7,'#F6D77A'],[214,96,6,'#FFFFFF'],[394,92,6,'#F6D77A'],[150,350,5,'#F6D77A'],[456,344,6,'#FFFFFF'],[300,74,7,'#F6D77A'],[118,196,4,'#F6D77A'],[488,188,4,'#FFFFFF'],[250,128,3.5,'#FFFFFF'],[356,124,3.5,'#FFFFFF']].map(function(e){return '<path fill="'+e[3]+'" d="'+etoile(e[0],e[1],e[2])+'"/>'}).join('');



  // mise en page calibrée (disque de la photo + éléments imprimés)

  (function(){

    var L=LAYOUT,k=L.discR/194;

    $('[data-vn-impression]').setAttribute('transform','translate('+L.discX+' '+L.discY+') scale('+k+') translate(-300 -250)');

    var d=$('[data-vn-disque]');d.setAttribute('cx',L.discX);d.setAttribute('cy',L.discY);d.setAttribute('r',L.discR);

    $('[data-vn-socle]').setAttribute('height',L.discB);

    var c=$('[data-vn-nuage]');c.setAttribute('x',300-L.cloudW/2);c.setAttribute('y',L.cloudY);c.setAttribute('width',L.cloudW);c.setAttribute('height',L.cloudW/2);

    $('[data-vn-nom]').setAttribute('y',L.nameY);

  })();



  // contrôles

  $('[data-vn-nuages]').innerHTML=NUAGES.map(function(c){var nom=(VTX.nuages[c.id]||c.n);return '<button type="button" role="radio" data-nuage="'+c.id+'" aria-label="'+nom+'"><img src="'+img('nuage-'+c.id)+'" alt="" width="60" height="30" loading="lazy">'+nom+'</button>'}).join('');

  $('[data-vn-lettres]').innerHTML='ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map(function(l){return '<button type="button" role="radio" data-lettre="'+l+'">'+l+'</button>'}).join('');

  $('[data-vn-zoo]').innerHTML=ANIMAUX.map(function(a){var nom=(VTX.animaux[a[0]]||a[1]);var cherche=sansAccent((a[1]+' '+nom).toLowerCase());return '<button type="button" role="radio" data-animal="'+a[0]+'" data-n="'+cherche+'" title="'+nom+'"><img src="'+img(a[0])+'" alt="" width="66" height="66" loading="lazy"><span>'+nom+'</span></button>'}).join('');



  function ajusterNom(){

    var t=$('[data-vn-nom]'),fs=LAYOUT.nameS,max=LAYOUT.cloudW*.7;t.setAttribute('font-size',fs);

    try{var w=t.getComputedTextLength();if(w>max)t.setAttribute('font-size',(fs*max/w).toFixed(1))}catch(e){}

  }

  function rendu(){

    var cl=NUAGES.filter(function(c){return c.id===etat.nuage})[0], an=ANIMAUX.filter(function(a){return a[0]===etat.animal})[0];

    root.querySelectorAll('[data-nuage]').forEach(function(b){b.setAttribute('aria-checked',b.dataset.nuage===etat.nuage)});

    root.querySelectorAll('[data-lettre]').forEach(function(b){b.setAttribute('aria-checked',b.dataset.lettre===etat.initiale)});

    root.querySelectorAll('[data-animal]').forEach(function(b){b.setAttribute('aria-checked',b.dataset.animal===etat.animal)});

    $('[data-vn-val-nuage]').textContent=(VTX.nuages[cl.id]||cl.n); $('[data-vn-val-initiale]').textContent=etat.initiale; boutonIni.innerHTML='<span>'+VTX.i.recap_initiale+' : <b>'+etat.initiale+'</b></span><span class="vn__chevron" aria-hidden="true"></span>'; $('[data-vn-val-animal]').textContent=an[1];

    var reste=13-Array.from(etat.prenom).length; $('[data-vn-compteur]').textContent=reste+' '+(reste>1?VTX.i.restants_plusieurs:VTX.i.restants_un);

    boutonAni.innerHTML='<span class="vn__ani-choix"><img src="'+img(an[0])+'" alt="" width="34" height="34"><span>'+VTX.i.recap_animal+' : <b>'+(VTX.animaux[an[0]]||an[1])+'</b></span></span><span class="vn__chevron" aria-hidden="true"></span>';

    $('[data-vn-nuage]').setAttribute('href',img('nuage-'+cl.id));

    var i=$('[data-vn-initiale]'); i.textContent=etat.initiale; i.setAttribute('stroke',fonce(cl.c,.78));

    $('[data-vn-animal]').setAttribute('href',img(an[0])); placerAnimal(); if(REGLAGE) majReglage();

    var n=$('[data-vn-nom]'); n.textContent=etat.prenom||'Prénom'; n.setAttribute('fill',etat.prenom?fonce(cl.c,.42):fonce(cl.c,.7)); ajusterNom();

    $('[data-vn-p-nuage]').value=cl.n; $('[data-vn-p-initiale]').value=etat.initiale; $('[data-vn-p-animal]').value=an[1]; $('[data-vn-p-prenom]').value=etat.prenom;

  }

  var SVGNS='http://www.w3.org/2000/svg', lettreEl=$('[data-vn-initiale]');

  var queueTrait=document.createElementNS(SVGNS,'path'), queueFond=document.createElementNS(SVGNS,'path');

  queueTrait.setAttribute('fill','none'); queueTrait.setAttribute('stroke-width','7'); queueTrait.setAttribute('stroke-linejoin','round');

  queueFond.setAttribute('fill','#FFFFFF'); queueFond.setAttribute('fill-opacity','.9');

  lettreEl.parentNode.insertBefore(queueTrait,lettreEl); lettreEl.parentNode.insertBefore(queueFond,lettreEl.nextSibling);

  // Q redessiné : un O de la police + une queue qui part vers la droite (au lieu de descendre sur le prénom)

  function dessinerQueue(x,y,f){

    var P=function(a,b){return (x+a*f).toFixed(1)+' '+(y+b*f).toFixed(1)};

    return 'M'+P(-.06,-.06)+' C'+P(.06,-.13)+' '+P(.20,-.02)+' '+P(.32,.015)+' C'+P(.43,.045)+' '+P(.53,.02)+' '+P(.60,-.03)+' C'+P(.56,.05)+' '+P(.44,.095)+' '+P(.31,.075)+' C'+P(.18,.055)+' '+P(.06,0)+' '+P(-.06,.02)+' Z';

  }

  function decalage(l){var d=DECALAGES[l]||{};return{x:+d.x||0,y:+d.y||0,s:d.s?+d.s:1,iy:+d.iy||0,is:d.is?+d.is:1}}

  function placerAnimal(){

    var d=decalage(etat.initiale), t=LAYOUT.animS*d.s, a=$('[data-vn-animal]');

    a.setAttribute('x',300-t/2+d.x); a.setAttribute('y',LAYOUT.animY-t+d.y); a.setAttribute('width',t); a.setAttribute('height',t);

    var i=lettreEl, f=LAYOUT.initS*d.is, yb=LAYOUT.initY+d.iy, estQ=etat.initiale==='Q';

    i.setAttribute('font-size',f); i.setAttribute('y',yb); i.textContent=estQ?'O':etat.initiale;

    queueTrait.style.display=queueFond.style.display=estQ?'':'none';

    if(estQ){var dq=dessinerQueue(300,yb,f); queueTrait.setAttribute('d',dq); queueFond.setAttribute('d',dq); queueTrait.setAttribute('stroke',i.getAttribute('stroke'))}

  }

  function premiereLettre(t){var c=sansAccent(t).replace(/[^A-Za-z]/g,'');return c?c[0].toUpperCase():null}



  var grille=$('[data-vn-lettres]'), boutonIni=document.createElement('button');

  boutonIni.type='button'; boutonIni.className='vn__ini-bouton'; boutonIni.setAttribute('aria-expanded','false');

  grille.parentNode.insertBefore(boutonIni,grille); grille.classList.add('vn__lettres--repli');

  function fermerLettres(){grille.classList.remove('is-ouvert');boutonIni.setAttribute('aria-expanded','false')}

  boutonIni.addEventListener('click',function(){var o=!grille.classList.contains('is-ouvert');grille.classList.toggle('is-ouvert',o);boutonIni.setAttribute('aria-expanded',o)});

  // animal en menu déroulant : la recherche et la grille se déplient au clic

  var zoo=$('[data-vn-zoo]'), recherche=$('[data-vn-recherche]'), boiteZoo=document.createElement('div'), boutonAni=document.createElement('button');

  boiteZoo.className='vn__zoo-repli'; boutonAni.type='button'; boutonAni.className='vn__ini-bouton vn__ani-bouton'; boutonAni.setAttribute('aria-expanded','false');

  recherche.parentNode.insertBefore(boutonAni,recherche); boutonAni.parentNode.insertBefore(boiteZoo,boutonAni.nextSibling);

  boiteZoo.appendChild(recherche); boiteZoo.appendChild(zoo);

  function fermerZoo(){boiteZoo.classList.remove('is-ouvert');boutonAni.setAttribute('aria-expanded','false')}

  boutonAni.addEventListener('click',function(){var o=!boiteZoo.classList.contains('is-ouvert');boiteZoo.classList.toggle('is-ouvert',o);boutonAni.setAttribute('aria-expanded',o);if(o&&window.innerWidth>768)recherche.focus()});

  root.addEventListener('click',function(e){

    var b=e.target.closest('button'); if(!b||!root.contains(b)) return;

    if(b.dataset.nuage){etat.nuage=b.dataset.nuage}

    else if(b.dataset.lettre){etat.initiale=b.dataset.lettre;etat.manuel=true;fermerLettres()}

    else if(b.dataset.animal){etat.animal=b.dataset.animal;fermerZoo()}

    else return;

    rendu(); montrerApercu();

  });

  $('[data-vn-recherche]').addEventListener('input',function(e){

    var q=sansAccent(e.target.value.trim().toLowerCase());

    root.querySelectorAll('[data-animal]').forEach(function(b){b.hidden=!!q&&b.dataset.n.indexOf(q)<0});

  });

  $('[data-vn-prenom]').addEventListener('input',function(e){

    var v=e.target.value.replace(/[^A-Za-zÀ-ÖØ-öø-ÿŒœ' \-]/g,'').replace(/\s{2,}/g,' ');

    v=Array.from(v).slice(0,13).join(''); if(v!==e.target.value) e.target.value=v;

    etat.prenom=v.trim(); if(!etat.prenom) etat.manuel=false;

    if(!etat.manuel){var f=premiereLettre(etat.prenom); if(f) etat.initiale=f}

    $('[data-vn-erreur]').hidden=true; rendu(); montrerApercu();

  });

  // option ajoutée au panier avec la veilleuse : adaptateur secteur USB (la carte de vœux est en pause)

  var OPTION={handle:'adaptateur-usb-prise-secteur-220v',variante:47304866333003,prixNum:4.49,

    titre:VTX.i.adaptateur_titre,texte:VTX.i.adaptateur_aide};

  var caseCarte=$('[data-vn-carte-case]'), msgCarte=$('[data-vn-carte-message]'), blocOption=caseCarte.closest('.vn__carte');

  if(msgCarte) msgCarte.parentNode.removeChild(msgCarte);

  OPTION.prixNum=4.49;

  // le prix du bouton « Ajouter au panier » (et de la barre collante) inclut l'option cochée

  var prixBase=null;

  function lirePrix(t){var m=String(t||'').replace(/\s/g,'').match(/(\d+)[.,](\d{2})/);return m?parseFloat(m[1]+'.'+m[2]):null}

  function majPrixBouton(){

    var cibles=document.querySelectorAll('.kp-btn-prix'); if(!cibles.length) return;

    if(prixBase===null) prixBase=lirePrix(cibles[0].textContent); if(prixBase===null) return;

    var txt=money(Math.round((prixBase+(caseCarte.checked?OPTION.prixNum:0))*100));

    [].forEach.call(cibles,function(c){if(c.textContent!==txt) c.textContent=txt});

  }

  caseCarte.addEventListener('change',majPrixBouton);

  new MutationObserver(function(){majPrixBouton()}).observe(document.body,{childList:true,subtree:true,characterData:true});

  blocOption.querySelector('strong').textContent=OPTION.titre;

  blocOption.querySelector('small').textContent=OPTION.texte;

  var prixOption=blocOption.querySelector('em'); prixOption.textContent=OPTION.prixNum?('+'+money(Math.round(OPTION.prixNum*100))):'';

  var vignette=document.createElement('img'); vignette.alt=''; vignette.width=48; vignette.height=48;

  vignette.setAttribute('style','width:48px;height:48px;object-fit:contain;border-radius:6px;background:#fff;flex:none;display:none');

  blocOption.insertBefore(vignette,blocOption.children[1]);

  fetch('/products/'+OPTION.handle+'.js').then(function(r){return r.json()}).then(function(p){

    var v=(p.variants||[]).filter(function(x){return x.id===OPTION.variante})[0]||p.variants[0];

    if(v){OPTION.variante=v.id; OPTION.prixNum=v.price/100; prixOption.textContent='+'+money(v.price); if(!v.available){blocOption.style.display='none';caseCarte.checked=false} majPrixBouton()}

    if(p.featured_image){vignette.src=p.featured_image.replace(/(\.[a-z]+)(\?|$)/i,'_96x96$1$2'); vignette.style.display=''}

  }).catch(function(){});



  // s'installe dans le formulaire produit, juste avant le bouton d'ajout au panier

  var form=document.querySelector('form[data-product-form]')||document.querySelector('form[action*="/cart/add"]');

  if(form){

    var cible=form.querySelector('.product-single__add-to-cart');

    if(cible) cible.parentNode.insertBefore(root,cible); else form.appendChild(root);

  }



  // ordinateur + mobile : l'aperçu prend la place de la photo vierge dans le carrousel

  var apercu=APERCU, svg=apercu.querySelector('svg'), galerie=null;

  var media=document.querySelector('.product-single__media-group .product-single__media-wrapper .product--wrapper')||document.querySelector('.product-single__media-group .product-single__media');

  if(media){

    if(getComputedStyle(media).position==='static') media.style.position='relative';

    media.appendChild(apercu); apercu.classList.add('vn__apercu--galerie');

    galerie=media.closest('.product-single__media-wrapper')||media;

    var note=root.querySelector('.vn__note'); if(note) note.hidden=true;

  }

  function montrerApercu(){

    // si le client regarde une autre image du carrousel, on revient sur l'aperçu

    if(!galerie) return;

    var slider=galerie.closest('.slick-slider'), jq=window.jQuery;

    if(slider&&jq&&jq.fn&&jq.fn.slick){

      var $s=jq(slider), idx=jq(galerie).closest('.slick-slide').data('slick-index')||0;

      if($s.slick('slickCurrentSlide')!==idx) $s.slick('slickGoTo',idx);

      return;

    }

    if(galerie.offsetParent!==null) return;

    var id=(galerie.id||'').split('-').pop();

    var vignette=id&&document.querySelector('[data-thumbnail-id$="'+id+'"],[data-media-id$="'+id+'"],[href*="'+id+'"]');

    if(vignette) vignette.click();

  }



  // mobile : aperçu fixé en haut de l'écran, des options jusqu'au bouton d'ajout au panier

  var sceneId='vnScene-'+Math.random().toString(36).slice(2,8), scene=document.createElementNS('http://www.w3.org/2000/svg','g');

  scene.setAttribute('id',sceneId);

  Array.prototype.slice.call(svg.childNodes).forEach(function(n){if(n.nodeName!=='defs') scene.appendChild(n)});

  svg.appendChild(scene);

  var flot=document.createElement('div'); flot.className='vn-flottant'; flot.setAttribute('aria-hidden','true');

  flot.innerHTML='<div class="vn-flottant__vue"><svg viewBox="0 0 600 600"><use href="#'+sceneId+'"/></svg></div>';

  document.body.appendChild(flot);



  // mobile : loupes + / − uniquement sur l'aperçu fixe, zoom centré sur le disque imprimé

  var ZOOMS=[1,1.4,1.8], niveauZoom=0, vues=[flot.querySelector('svg')], groupesZoom=[];

  var LOUPE='<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21"/>';

  function controlesZoom(conteneur){

    var g=document.createElement('div'); g.className='vn-zoom';

    g.innerHTML='<button type="button" data-zoom="1" aria-label="Zoomer sur l\'aperçu">'+LOUPE+'<path d="M10.5 7.5v6M7.5 10.5h6"/></svg></button>'

      +'<button type="button" data-zoom="-1" aria-label="Dézoomer l\'aperçu">'+LOUPE+'<path d="M7.5 10.5h6"/></svg></button>';

    g.addEventListener('click',function(e){var b=e.target.closest('[data-zoom]');if(!b)return;e.preventDefault();e.stopPropagation();

      niveauZoom=Math.max(0,Math.min(ZOOMS.length-1,niveauZoom+(+b.dataset.zoom)));appliquerZoom()});

    conteneur.appendChild(g); groupesZoom.push(g);

  }

  function appliquerZoom(){

    var z=ZOOMS[niveauZoom];

    vues.forEach(function(v){v.style.transformOrigin='51.7% 46%';v.style.transform=z===1?'':'scale('+z+')'});

    groupesZoom.forEach(function(g){g.querySelector('[data-zoom="1"]').disabled=niveauZoom===ZOOMS.length-1;g.querySelector('[data-zoom="-1"]').disabled=niveauZoom===0});

  }

  controlesZoom(flot); appliquerZoom(); // loupes dans la marge blanche, en bas à droite

  var zonePanier=form&&form.querySelector('.product-single__add-to-cart');

  function majFlottant(){

    if(window.innerWidth>768){flot.classList.remove('is-visible');return}

    var h=flot.offsetHeight||300, a=apercu.getBoundingClientRect(), o=root.getBoundingClientRect(), p=(zonePanier||root).getBoundingClientRect();

    flot.classList.toggle('is-visible', a.bottom<=h && p.bottom>h);

  }

  window.addEventListener('scroll',majFlottant,{passive:true}); window.addEventListener('resize',majFlottant);



  // contrôle avant l'ajout au panier (bouton principal et barre collante)

  var carteAjoutee=false;

  function boutonAjout(t){return t.closest&&t.closest('button[name="add"], .btn--add-to-cart, [data-sticky-addtocart], .dbtfy-sticky-addtocart button')}

  document.addEventListener('click',function(e){

    var b=boutonAjout(e.target); if(!b) return;

    if(!etat.prenom){

      e.preventDefault(); e.stopImmediatePropagation();

      $('[data-vn-erreur]').hidden=false; $('[data-vn-prenom]').focus();

      root.scrollIntoView({behavior:'smooth',block:'center'}); return;

    }

    if(caseCarte.checked&&!carteAjoutee){

      e.preventDefault(); e.stopImmediatePropagation();

      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},

        body:JSON.stringify({items:[{id:Number(OPTION.variante),quantity:1}]})})

        .then(function(){carteAjoutee=true;b.click()})

        .catch(function(){carteAjoutee=true;b.click()});

    }

  },true);

  if(form) form.addEventListener('submit',function(e){

    if(!etat.prenom){e.preventDefault();e.stopImmediatePropagation();$('[data-vn-erreur]').hidden=false;$('[data-vn-prenom]').focus()}

  },true);



  // panneau de réglage par lettre, visible seulement avec #reglages dans l'adresse

  var panneau=null;

  function majReglage(){

    if(!panneau) return; var d=decalage(etat.initiale);

    panneau.querySelector('[data-r-lettre]').textContent=etat.initiale;

    [['x',d.x],['y',d.y],['s',Math.round(d.s*100)],['iy',d.iy],['is',Math.round(d.is*100)]].forEach(function(k){var r=panneau.querySelector('[data-r="'+k[0]+'"]');r.value=k[1];panneau.querySelector('[data-o="'+k[0]+'"]').textContent=k[1]});

    panneau.querySelector('[data-r-sortie]').value=JSON.stringify(DECALAGES);

    panneau.querySelector('[data-r-faites]').textContent=Object.keys(DECALAGES).sort().join(' ')||'aucune';

  }

  if(REGLAGE){

    panneau=document.createElement('div');

    panneau.setAttribute('style','border:2px dashed #aa7add;border-radius:8px;padding:12px;margin:10px 0;background:#faf8ff;font-size:13px');

    panneau.innerHTML='<strong style="color:#212529">Réglage de l\'animal pour la lettre <span data-r-lettre></span></strong>'

      +'<p style="margin:4px 0 10px;opacity:.8">Clique sur une lettre ci-dessus, puis place l\'animal. Chaque lettre garde son réglage.</p>'

      +[['x','Animal : gauche / droite',-160,160],['y','Animal : haut / bas',-140,80],['s','Animal : taille (%)',50,140],['iy','Lettre : haut / bas',-120,60],['is','Lettre : taille (%)',60,120]].map(function(k){

        return '<label style="display:grid;grid-template-columns:150px 1fr 40px;gap:8px;align-items:center;margin:6px 0">'+k[1]

          +'<input type="range" data-r="'+k[0]+'" min="'+k[2]+'" max="'+k[3]+'" step="1" style="width:100%;accent-color:#aa7add"><output data-o="'+k[0]+'"></output></label>'}).join('')

      +'<p style="margin:8px 0 4px">Lettres réglées : <b data-r-faites></b></p>'

      +'<div style="display:flex;gap:8px;flex-wrap:wrap;margin:8px 0"><button type="button" data-r-copier style="border:1px solid #aa7add;background:#aa7add;color:#fff;border-radius:6px;padding:8px 12px;font:inherit;cursor:pointer">Copier les réglages</button>'

      +'<button type="button" data-r-zero style="border:1px solid #d8c6ff;background:#fff;border-radius:6px;padding:8px 12px;font:inherit;cursor:pointer">Remettre cette lettre au centre</button></div>'

      +'<textarea data-r-sortie readonly style="width:100%;min-height:56px;font:12px monospace;border:1px solid #d8c6ff;border-radius:6px;padding:6px"></textarea>'

      +'<p data-r-msg style="margin:4px 0 0;color:#3f8f6b;font-weight:600" hidden></p>';

    var champLettres=root.querySelector('[data-vn-lettres]').parentNode; champLettres.appendChild(panneau);

    panneau.addEventListener('input',function(e){

      var k=e.target.dataset.r; if(!k) return;

      var d=decalage(etat.initiale); d[k]=(k==='s'||k==='is')?(+e.target.value)/100:+e.target.value;

      DECALAGES[etat.initiale]={x:d.x,y:d.y,s:Math.round(d.s*100)/100,iy:d.iy,is:Math.round(d.is*100)/100};

      try{localStorage.setItem('vn-decalages',JSON.stringify(DECALAGES))}catch(_){}

      placerAnimal(); majReglage();

    });

    panneau.addEventListener('click',function(e){

      if(e.target.closest('[data-r-zero]')){delete DECALAGES[etat.initiale];try{localStorage.setItem('vn-decalages',JSON.stringify(DECALAGES))}catch(_){}placerAnimal();majReglage();}

      if(e.target.closest('[data-r-copier]')){

        var t=panneau.querySelector('[data-r-sortie]'),m=panneau.querySelector('[data-r-msg]');

        var ok=function(){m.textContent='Réglages copiés : colle-les dans la conversation.';m.hidden=false};

        try{navigator.clipboard.writeText(t.value).then(ok,function(){t.select();m.textContent='Sélectionné : fais Ctrl+C.';m.hidden=false})}catch(_){t.select();m.textContent='Sélectionné : fais Ctrl+C.';m.hidden=false}

      }

    });

  }



  var champPrenom=root.querySelector('.vn__prenom'), voir=document.createElement('button');

  voir.type='button'; voir.className='vn__voir'; voir.textContent=VTX.i.bouton_apercu;

  champPrenom.parentNode.insertBefore(voir,champPrenom.nextSibling);

  var fen=document.createElement('div'); fen.className='vn-fenetre'; fen.hidden=true;

  fen.setAttribute('role','dialog'); fen.setAttribute('aria-modal','true'); fen.setAttribute('aria-label',VTX.i.aria_apercu);

  fen.innerHTML='<div class="vn-fenetre__boite"><button type="button" class="vn-fenetre__fermer" aria-label="Fermer">&times;</button>'

    +'<svg viewBox="0 0 600 600"><use href="#'+sceneId+'"/></svg><p class="vn-fenetre__texte"></p></div>';

  document.body.appendChild(fen);

  function ouvrirFen(){

    var cl=NUAGES.filter(function(x){return x.id===etat.nuage})[0], an=ANIMAUX.filter(function(x){return x[0]===etat.animal})[0];

    fen.querySelector('.vn-fenetre__texte').textContent=VTX.i.recap_nuage+' '+(VTX.nuages[cl.id]||cl.n)+' · '+VTX.i.recap_initiale+' '+etat.initiale+' · '+(VTX.animaux[an[0]]||an[1])+(etat.prenom?' · '+etat.prenom:'');

    fen.hidden=false; fen.querySelector('.vn-fenetre__fermer').focus();

  }

  function fermerFen(){fen.hidden=true; voir.focus()}

  voir.addEventListener('click',ouvrirFen);

  fen.addEventListener('click',function(e){if(e.target===fen||e.target.closest('.vn-fenetre__fermer')) fermerFen()});

  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!fen.hidden) fermerFen()});



  var sp=document.createElement('script'); sp.src=BASE+'vn-veilleuse-panier-v2.js'; sp.defer=true; document.head.appendChild(sp);



  rendu(); majFlottant(); majPrixBouton();

  if(document.fonts&&document.fonts.ready) document.fonts.ready.then(ajusterNom);

  }

  function go(){document.querySelectorAll('[data-vn]').forEach(init)}

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',go); else go();

})();

